import React, {useCallback, useRef, useState} from 'react';
import styles from "../styles.module.scss";
import cn from "classnames";
import {INPUT_STACK} from "../initialInputs";
import useTranslation from "next-translate/useTranslation";
import {TRAINING_NAMESPACE} from "../../../../../utils/i18nNameSpaces";

const Index = ({handleInputValueChange, stackList, extraT}) => {
  const {t} = useTranslation(TRAINING_NAMESPACE);
  const [isActive, setIsActive] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const inputRef = useRef(null);

  const togglePopoverActive = useCallback(
    () => setIsActive(state => !state),
    [],
  );

  const handleInputValue = useCallback( (value) => {
    setInputValue(value);
    setIsActive(false);
    handleInputValueChange({
      name: INPUT_STACK,
      value: value
    });
  }, [])

  return (
    <div className={cn(styles["stack-label"], styles["form__input-label"])}>
      <label
        className={cn(styles["form__input-label"])}
        onClick={togglePopoverActive}
        style={{
          cursor: "pointer",
          position: "relative"
        }}
      >
        <span className={styles["form__input-title"]}>{extraT ? extraT("stack.name") : t("appForm.inputs.stack.name")}</span>
        <input
          type="text"
          className={styles["form__input"]}
          placeholder={extraT ? extraT("stack.placeholder") : t("appForm.inputs.stack.placeholder")}
          name={INPUT_STACK}
          style={{
            cursor: "pointer",
            caretColor: "transparent"
          }}
          readOnly
          ref={inputRef}
          value={inputValue}
          autoComplete="off"
        />
        <div className={styles["input-arrow"]} onClick={togglePopoverActive}>
          <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M6.00001 7.00001C5.74401 7.00001 5.48801 6.90201 5.29301 6.70701L0.293006 1.70701C-0.0979941 1.31601 -0.0979941 0.684006 0.293006 0.293006C0.684006 -0.0979941 1.31601 -0.0979941 1.70701 0.293006L6.00001 4.58601L10.293 0.293006C10.684 -0.0979941 11.316 -0.0979941 11.707 0.293006C12.098 0.684006 12.098 1.31601 11.707 1.70701L6.70701 6.70701C6.51201 6.90201 6.25601 7.00001 6.00001 7.00001Z" fill="#5C5F62"/>
          </svg>
        </div>
      </label>
      <ul className={cn(styles["stack__list"], {[styles["list--active"]]: isActive})}>
        {stackList.map((el, i) => (
          <li className={styles["stack__item"]} onClick={() => handleInputValue(el)} key={i}>
            {el}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Index;